module.exports = __webpack_public_path__ + "static/media/newUser.2dad13e7.svg";